<template>
  <div class="book-page">
    <div class="page-title">课程列表</div>
    <el-table :data="courses" v-loading="loading" stripe>
      <el-table-column prop="courseName" label="课程" min-width="220" />
      <el-table-column prop="textbookCount" label="教材数" width="100" />
      <el-table-column prop="knowledgeCount" label="知识点数" width="120" />
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <el-button type="text" @click="goTextbook(scope.row)"
            >查看教材</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBookCourseList } from "@/api/book";

export default {
  name: "BookCourseIndex",
  data() {
    return {
      loading: false,
      courses: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await getBookCourseList();
        if (res.code === 200 || res.code === 0) {
          this.courses = res.data || [];
        } else {
          this.$message.error(res.message || "加载课程失败");
        }
      } finally {
        this.loading = false;
      }
    },
    goTextbook(row) {
      this.$router.push({
        path: "/bookTextbook",
        query: {
          courseId: row.id,
          courseName: row.courseName
        }
      });
    }
  }
};
</script>

<style scoped>
.book-page {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>
